export default __webpack_public_path__ + "static/media/mixed nuts.5de81a43.jpg";